import { Box } from '@mui/material';
import { ProjectTable } from 'modules/components/layer25';
import React from 'react';



export type ProjectsDetailSectionProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: ProjectsDetailSectionProps) => {

  return (
    <Box
      display='flex'
      flexDirection='column'
    >
      <ProjectTable.FC />
    </Box>
  );
};
